import { Divider } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import {
  Accordion,
  AccordionProps,
} from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';

export function AccordionRule({
  expanded,
  ...props
}: AccordionProps): JSX.Element {
  return (
    <>
      <Accordion {...props} expanded={expanded} />
      {!expanded && <Divider aria-label="divider" />}
    </>
  );
}
